import styles from './DocumentNavigation.module.css';
import DownloadIcon from '@mui/icons-material/Download';
import NextIcon from '@mui/icons-material/ArrowForwardIos';
import PrevIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';

const DocumentNavigation = ({ onDownloadFile, onNext, onPrev, onClose, pageNo, totalDocs, disabled }) => {
  const pageNumber = `${' '}${pageNo} / ${totalDocs}`;
  return (
    <div className={styles.navigationContainer}>
      <div className={styles.downloadButtonContainer}>
        <button type="button" onClick={onDownloadFile} disabled={disabled}>
          <DownloadIcon />
        </button>
      </div>
      <div>
        <button type="button" onClick={onPrev} disabled={disabled || pageNo <= 1}>
          <PrevIcon />
        </button>
      </div>
      <div className={styles.pageNumberContainer}>
        <div>{pageNumber}</div>
      </div>
      <div>
        <button type="button" onClick={onNext} disabled={disabled || pageNo >= totalDocs}>
          <NextIcon />
        </button>
      </div>
      <div className={styles.closeButtonContainer}>
        <button type="button" onClick={onClose}>
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default DocumentNavigation;
